// extracted by mini-css-extract-plugin
module.exports = {"dividerText":"_7ee9c09","activeLink":"_024082f","icon":"_0b812da"};